<template>
  <div class="text-lg mb-4 text-left">รายการ {{ props.title }}</div>
  <form class="flex flex-row justify-between sm:mr-auto">
    <div class="sm:flex items-center sm:mr-4">
      <select
        v-model="optionSelected"
        @change="findItem"
        class="form-select w-full sm:w-32 xxl:w-full mt-2 sm:mt-0 sm:w-auto"
        :disabled="props.isEdit"
      >
        <option :value="null">เลือก {{ props.title }}</option>
        <option v-for="opt in options" :key="opt.value" :value="opt.value">{{
          opt.label
        }}</option>
      </select>
    </div>
    <div>
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        v-show="props.btnClosed"
        @click="closed"
      >
        ปิด
      </button>
      <button
        type="button"
        class="btn btn-warning"
        data-dismiss="modal"
        v-show="props.btnConfirm"
        @click="confirmItem"
      >
        ยืนยัน
      </button>
    </div>
  </form>
  <div
    id="tabulator"
    ref="tableRef"
    class="mt-5 table-report table-report--tabulator"
  ></div>
</template>

<script>
import Tabulator from 'tabulator-tables'
// import { defineComponent, ref, onMounted, computed, watch } from 'vue'
import { defineComponent, ref, onMounted, watch, computed } from 'vue'
// import { useStore } from '@/store'
import helpers from '@/helpers'
import feather from 'feather-icons'
export default defineComponent({
  name: 'table-list-selected-gr',
  props: {
    title: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    data: {
      type: Array,
      required: true,
      default: () => null
    },
    hasOption: {
      type: Boolean,
      default: () => false
    },
    fieldOptions: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          value: 'value'
        }
      }
    },
    btnConfirm: {
      type: Boolean,
      default: () => true
    },
    btnClosed: {
      type: Boolean,
      default: () => true
    },
    isEdit: {
      type: Boolean,
      default: () => false
    },
    itemsSelected: {
      type: Array,
      default: () => []
    },
    mainSelected: {
      type: Object,
      default: () => null
    },
    displayStatus: {
      type: String,
      default: () => 'hide'
    }
  },
  emits: ['confirm', 'closed'],
  setup(props, context) {
    const optionSelected = ref(null)
    const options = ref([])
    const tableRef = ref()
    const tabulator = ref()
    const chosen = ref(null)
    const chosenItems = ref([])
    const items = ref([])
    const { numberFormat } = helpers
    const data = computed(() => props.data)
    const itemDelete = ref([])

    const genOptions = () => {
      const labels = props.fieldOptions.label.split(',')
      options.value = data.value.map(item => {
        const val = labels.map(f => (item[f] ? item[f] : 'ไม่ระบุ'))
        return {
          label: val.join(' - '),
          value: item[props.fieldOptions.value]
        }
      })
      clearData()
    }

    const clearData = () => {
      chosen.value = null
      optionSelected.value = null
      chosenItems.value = []
      itemDelete.value = []
      tabulator.value.setData(chosenItems.value)
    }

    const pushItem = item => {
      items.value.push(item)
    }

    const initTabulator = async () => {
      tabulator.value = new Tabulator(tableRef.value, {
        ajaxLoader: true,
        placeholder: 'ไม่พบข้อมูลที่ต้องการ',
        paginationSize: 10,
        paginationSizeSelector: [10, 20, 30, 40],
        data: chosenItems.value,
        columns: [
          {
            title: 'เลือก',
            field: 'po_item_id',
            formatter: cell => {
              const hasClass = cell.getData().selected
                ? 'btn-warning'
                : 'btn-outline-secondary'
              const disabled =
                cell.getData().amount == 0 && cell.getData().qty == 0
                  ? 'btn-secondary-soft'
                  : ''
              const btn = cash(`<div class="flex lg:justify-center items-center">
                <button type="button" class="btn ${hasClass} ${disabled}"><i data-feather="check-square" class="w-4 h-4 mr-1"></i> เลือก</button>
              </div>`)

              if (cell.getData().amount != 0 || cell.getData().qty != 0) {
                cash(btn).on('click', e => {
                  if (
                    cash(btn)
                      .find('button')
                      .hasClass('btn-warning')
                  ) {
                    removeItem(cell.getData().po_item_id)
                    cash(btn)
                      .find('button')
                      .removeClass('btn-warning')
                      .addClass('btn-outline-secondary')
                  } else {
                    pushItem(cell.getData())
                    cash(btn)
                      .find('button')
                      .removeClass('btn-outline-secondary')
                      .addClass('btn-warning')
                  }
                })
              }
              return btn[0]
            }
          },
          {
            title: 'รายละเอียดสินค้า',
            field: 'item_name',
            width: '500'
          },
          {
            title: 'ราคาต่อหน่วย (ไม่รวมภาษี)',
            field: 'unit_price',
            hozAlign: 'right',
            formatter: cell => {
              return numberFormat(cell.getData().unit_price)
            }
          },
          {
            title: 'จำนวนสินค้า',
            field: 'qty',
            hozAlign: 'right',
            formatter: cell => {
              return numberFormat(cell.getData().qty)
            }
          },
          {
            title: 'หน่วยนับ',
            field: 'uom'
          },
          {
            title: 'ราคาก่อนรวมภาษี',
            field: 'amount',
            hozAlign: 'right',
            formatter: cell => {
              return numberFormat(cell.getData().amount)
            }
          },
          {
            title: 'ภาษีมูลค่าเพิ่ม',
            field: 'vat',
            hozAlign: 'right',
            formatter: cell => {
              return numberFormat(cell.getData().vat)
            }
          },
          {
            title: 'รวมเป็นเงินทั้งหมด',
            field: 'actual_cost',
            hozAlign: 'right',
            formatter: cell => {
              return numberFormat(cell.getData().actual_cost)
            }
          }
        ],
        renderComplete() {
          feather.replace({
            'stroke-width': 1.5
          })
        }
      })
    }

    const removeItem = poItemId => {
      const oldItems = items.value.find(item => item.po_item_id == poItemId)
      if (oldItems) {
        itemDelete.value.push(oldItems)
      }
      const newItems = items.value.filter(item => item.po_item_id !== poItemId)
      items.value = newItems
    }

    const findItem = () => {
      if (optionSelected.value !== null) {
        chosen.value = data.value.find(
          item => item[props.fieldOptions.value] == optionSelected.value
        )
      } else {
        clearData()
      }
    }

    const setSelectedItems = data => {
      const newData = data.map(d => {
        d.selected = !!props.itemsSelected.find(
          s => s.po_item_id == d.po_item_id
        )
        return d
      })
      tabulator.value.setData(newData)
    }

    watch(chosen, newVal => {
      // console.log('newVal: ', chosen, newVal)
      if (newVal !== null && newVal !== undefined) {
        chosenItems.value = chosen.value.items
        setSelectedItems(chosenItems.value)
        itemDelete.value = []
        if (props.mainSelected) {
          items.value =
            newVal.po_id === props.mainSelected.po_id
              ? [...props.itemsSelected]
              : []
        } else {
          items.value = []
        }
      }
    })

    watch(
      () => props.data,
      newVal => {
        if (props.hasOption) {
          genOptions()
        }
      }
    )

    const confirmItem = () => {
      context.emit('confirm', {
        chosen: chosen.value,
        chosenItems: [...items.value]
      })
      context.emit('closed')
    }

    const closed = async () => {
      context.emit('closed')
      if (props.mainSelected) {
        optionSelected.value = props.mainSelected.po_id
        await findItem()
      }
      items.value = props.itemsSelected
    }

    watch(
      () => props.displayStatus,
      newVal => {
        // console.log('watch display: ', newVal)
        if (newVal == 'open') {
          items.value = [...props.itemsSelected]
          setSelectedItems(chosenItems.value)
        } else {
          itemDelete.value = []
        }
      }
    )

    onMounted(() => {
      initTabulator()
      if (props.hasOption) {
        genOptions()
      }
    })

    return {
      tableRef,
      optionSelected,
      options,
      findItem,
      chosen,
      chosenItems,
      confirmItem,
      itemDelete,
      closed,
      items,
      props
    }
  }
})
</script>
